<div class="min-h-screen bg-gray-100 flex flex-col">

  <!-- HEADER -->
  <header class="w-full bg-gray-100">
    <div class="w-full max-w-[950px] mx-auto px-4 py-2 flex items-center justify-between">

      <!-- Heure (gauche) -->
      <div class="text-sm text-gray-700 cursor-pointer select-none" (click)="openPinModal()">
        {{ currentTime | date:'EEE d MMM, HH:mm:ss':'fr-CA' }}
      </div>

      <!-- Logo centré -->
      <div class="flex-1 flex justify-center">
        <img src="/assets/images/Logo-Matwins.png" alt="Logo Matwins" class="w-40 h-20 object-contain">
      </div>

      <!-- Change Language (droite) -->
      <div class="flex items-center">
        <div class="relative" (clickOutside)="closeLangMenu()">
          <button (click)="toggleLangMenu()"
            class="px-2 py-1 bg-transparent text-sm text-gray-700 flex items-center cursor-pointer">
            <i class="fas fa-globe mr-2"></i>
            Change Language
            <i class="fas fa-chevron-down ml-2"></i>
          </button>

          @if (langMenuOpen) {
          <div class="absolute top-full right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-50">
            @for (lang of languages; track lang.key) {
            <button (click)="changeLanguage(lang.key)" [class.bg-blue-50]="currentLanguage === lang.key"
              class="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center">
              @if (lang.logoPath) {
              <img [src]="lang.logoPath" [alt]="lang.name" class="w-4 h-4 mr-2 object-contain">
              } @else {
              <span class="mr-2">{{ getFlagEmoji(lang.key) }}</span>
              }
              {{ lang.name }} ({{ lang.key }})
            </button>
            }
          </div>
          }
        </div>
      </div>

    </div>
  </header>

  <!-- Template réutilisable du loader -->
  <ng-template #loaderBody>
    <div class="relative">
      <div class="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin border-t-blue-500"></div>
      <div class="absolute inset-0 w-16 h-16 border-4 border-transparent rounded-full animate-ping border-t-blue-300"></div>
    </div>
    <p class="text-gray-700 font-medium text-lg">{{ 'app.loading' | translate }}</p>
    <div class="w-32 h-1 bg-gray-200 rounded-full overflow-hidden">
      <div class="h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
    </div>
  </ng-template>

  <!-- CONTENU CENTRAL -->
  <main class="flex-1 overflow-y-auto w-full max-w-[950px] mx-auto px-6 py-0 min-w-[320px]">
    @if(isErrorPage || (authentificationService.userVerified() && currentTenantService.currentPointOfService())) {
    <router-outlet></router-outlet>
    } @else if (authentificationService.userVerified()) {
    <div class="flex flex-col items-center justify-center h-full pt-20 space-y-4">
      <ng-container *ngTemplateOutlet="loaderBody"></ng-container>
    </div>
    }
  </main>

  <!-- Loader full-screen -->
  @if (loaderService.loading$ | async) {
  <div
    class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center z-[9999] animate-fadeIn">
    <div class="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center space-y-4 animate-slideIn">
      <ng-container *ngTemplateOutlet="loaderBody"></ng-container>
    </div>
  </div>
  }

  @if (showPinModal) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" (click)="closePinModal()">
    <div class="bg-white p-6 rounded-xl shadow-2xl w-72" (click)="$event.stopPropagation()">
      <div class="text-center mb-4">
        <div class="text-2xl font-bold tracking-widest h-8">
          {{ getPinMask() }}
        </div>
      </div>
      <div class="grid grid-cols-3 gap-3 mb-3">
        @for (d of ['1','2','3','4','5','6','7','8','9']; track d) {
        <button (click)="addDigit(d)"
          class="w-16 h-16 rounded-full bg-gray-200 hover:bg-gray-300 text-xl font-semibold flex items-center justify-center transition">
          {{ d }}
        </button>
        }
      </div>
      <div class="grid grid-cols-2 gap-3">
        <button (click)="removeDigit()"
          class="w-16 h-16 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center text-lg">
          ⌫
        </button>
        <button (click)="addDigit('0')"
          class="w-16 h-16 rounded-full bg-gray-200 hover:bg-gray-300 text-xl font-semibold flex items-center justify-center">
          0
        </button>
      </div>
    </div>
  </div>
  }

</div>